module.exports = __webpack_public_path__ + "static/img/new.7824867f.jpg";